import en from './en';
import es from './es';
import pt from './pt-br';

export default {
  en,
  es,
  'pt-br': pt,
};
